import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/15.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Po wizycie u zduna – do szewca"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p30,
            }}
            content={
                <div>
                    <p>
                        Idziesz do warsztatu, z którego słychać głośne stukanie. Pukasz, ale nikt ci nie odpowiada. Pukasz głośniej i stukanie cichnie.
                    </p>
                    <ul>
                        <li>Kto tam? Wejść! – słyszysz.</li>
                    </ul>
                    <p>
                        Otwierasz drzwi. W maleńkiej izdebce na taborecie siedzi wąsaty mężczyzna i ćwiekuje buty. Wokół stołu rozrzucone są dratwy, nóż, drewniane kopyto, cęgi i inne narzędzia.
                    </p>
                    <ul>
                        <li>Dzień dobry! Kantor mówił mi, że może pan potrzebować pracownika.</li>
                        <li>Pracownika? A z czego ja ci zapłacę? Zmykaj stąd, bo robota mi się pali w rękach.</li>
                    </ul>
                </div>
            }
        />

    );
}